import React from 'react'
import Button from '../Button/Button'
import Image from '../../function/Image'
import Heading from '../../components/Heading/Heading'
import toCamelCase from './../../function/toCamelCaseString'
import './style.scss'
import parse from 'html-react-parser'

function Content({ basicBlock }) {
    const {
        textAlign,
        image,
        preHeader,
        title,
        headingType,
        description,
        buttons,
        background: { solidColor, videoBackground },
        socialButtons
    } = basicBlock
    return (
        <>
            {videoBackground && (
                <video
                    autoPlay
                    loop
                    muted
                    className="inset-0 absolute w-full h-full object-cover"
                >
                    <source src={videoBackground} type="video/mp4" />
                </video>
            )}
            <div className="container text-white relative">
                <div
                    className={`flex ${
                        textAlign === 'center'
                            ? 'md:justify-center'
                            : textAlign === 'right'
                            ? 'md:justify-end'
                            : 'md:justify-start'
                    }`}
                >
                    <div
                        className={`w-full justify-items-center sm:px-8 md:px-0  md:w-10/12 xl:w-5/12 `}
                    >
                        {image && (
                            <div className="w-20 aspect-square rounded-full overflow-hidden mb-[22px]">
                                <Image {...image} alt={preHeader} />
                            </div>
                        )}

                        {preHeader && (
                            <p
                                className="pre-header mb-[13px]"
                                style={{
                                    color:
                                        solidColor === ('rgb(255,255,255)' || 'rgb(255,255,255,0)')
                                            ? '#2b0838'
                                            : '#FFF'
                                }}
                            >
                                {preHeader}
                            </p>
                        )}
                        <div
                            className=""
                            style={{
                                color:
                                (solidColor ===  null || solidColor === 'rgb(255,255,255)')
                                        ? '#2b0838'
                                        : '#FFF'
                            }}
                        >
                            {title && (
                                <Heading heading={headingType}>
                                    <span className="mb-[21px] block">
                                        {parse(title)}
                                    </span>
                                </Heading>
                            )}
                            {description && (
                                <div className="basic-rich-text">
                                    {parse(description)}
                                </div>
                            )}
                        </div>

                        {buttons && (
                            <div className="flex w-full items-center gap-x-[29px] mt-[27px]">
                                {buttons.map((button, index) => {
                                    if (!button.buttonLink) return null
                                    const { arrow, buttonType, buttonLink } =
                                        button
                                    return (
                                        <div
                                            className=" mb-4 lg:mb-0"
                                            key={index}
                                        >
                                            <Button
                                                styles={toCamelCase(buttonType)}
                                                hasArrow={arrow}
                                                buttonLink={buttonLink}
                                            >
                                                {buttonLink?.title}
                                            </Button>
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                        {socialButtons && (
                            <div className="w-1/2 lg:w-fit social mb-12 xl:grow flex flex-col items-start lg:items-end">
                                <div className="flex justify-end items-center">
                                    {socialButtons?.map((item, index) => {
                                        if (!item?.link) return null
                                        const gradient =
                                            item.link.title === 'Twitter'
                                                ? 'from-han_purple to-aquamarine'
                                                : item.link.title === 'Facebook'
                                                ? 'from-sea_serpent  to-aquamarine'
                                                : 'from-light_pink to-han_purple'
                                        return (
                                            <a
                                                href={item.link.url}
                                                target={item.link.target}
                                                className={` relative flex justify-center items-center bg-gradient-to-tl ${gradient} ${
                                                    index === 1 && 'mx-3'
                                                } hover:saturate-200 transition-all p-3 rounded-[50%]  cursor-pointer`}
                                                key={index}
                                            >
                                                {item.icon && (
                                                    <Image
                                                        {...item.icon}
                                                        alt="social icon"
                                                    />
                                                )}
                                            </a>
                                        )
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Content
